module.exports = __webpack_public_path__ + "img/icon-adress.12e0b5af.svg";